import type { GeocodeResult } from '@evogard/ui';
import { api } from './api.js';

/**
 * O endereço → a posição, pela rota da plataforma — a função que o
 * `AddressField` recebe em `geocode`.
 *
 * O 404 é "o Google não achou", e vira `null`; o resto (sem chave do Google
 * na praça, Google fora) LANÇA, e o campo diz que não deu para procurar.
 */
export async function geocodeAddress(address: string): Promise<GeocodeResult | null> {
  const r = await api.maps.geocode({ body: { address } });
  if (r.status === 200)
    return { lat: r.body.lat, lng: r.body.lng, precise: r.body.precise };
  if (r.status === 404) return null;
  throw new Error('Não deu para procurar a posição do endereço.');
}
